module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagec",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0020-01.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0022-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("BRIOCHE & RED FRUIT SWIRLS WITH RICOTTA GLAZE")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_c('em', [_vm._v("Makes 10 substantial rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "ing1"
  }, [_c('strong', [_vm._v("FOR THE BRIOCHE SWIRLS")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("¼ cup (60 ml) lukewarm milk")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("⅓ cup (60 g) granulated sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("2¼ teaspoons (1 envelope) active dry yeast")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("2¾ cups (350 g) all-purpose flour, plus plenty for dusting")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("3 eggs, beaten")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("9 tablespoons (125 g) butter, at room temperature, cubed")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("½ cup (100 g) light brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("10½ ounces (300 g) frozen red fruit, preferably a mix")]), _vm._v(" "), _c('p', {
    staticClass: "ing1"
  }, [_c('strong', [_vm._v("FOR THE RICOTTA GLAZE")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("3 to 4 tablespoons ricotta")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("About 2 cups (200 g) sifted confectioners’ sugar")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Prepare")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a bowl, beat the milk together with the granulated sugar and yeast and let stand for 7 minutes, until the mixture starts foaming. Combine the flour and salt in a large bowl. Form an indentation in the middle. Pour in the yeast mixture and the beaten eggs, then gently combine into a smooth dough. Remove from the bowl and knead for 5 minutes on a floured countertop until supple and soft. Add two cubes of butter and continue kneading until they are incorporated into the dough. Repeat until all the butter has been used and the dough has become shiny and elastic, dusting the countertop with flour as you work and using a bench knife or spatula to scrape up the dough as needed—it may take a while to incorporate all that butter, but be persistent. Place the ball in a greased bowl, cover with plastic wrap, and allow to rise for 90 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again briefly knead the dough. Roll out on a lightly floured countertop into a 16 by 24-inch (40 by 60-cm) rectangle. Sprinkle with the brown sugar and frozen fruit. Now, roll up from a short side into a short, thick log. Wrap in plastic wrap. Place the roll in the freezer for 15 minutes to firm up, which will make slicing it easier later on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remove the plastic wrap. Using a sharp knife, cut the log into ten even slices. Place them on parchment paper–lined baking sheets, a little apart (they are still rising!). Cover loosely with plastic wrap and allow to continue rising for 30 minutes in a warm, draft-free spot. If you’d like to make these the evening before, let them rise overnight in the fridge on the baking sheets.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Make")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Allow brioches that were stored in the fridge 30 to 45 minutes to reach room temperature before you proceed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, preheat the oven to 350°F (180ºC).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Uncover the brioches and bake for 30 to 35 minutes, until golden brown. Let cool for a few minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the glaze, whisk the ricotta in a bowl and add confectioners’ sugar until you get a thick glaze with the consistency of whole milk yogurt. Drizzle over the buns. Let stand briefly to set the glaze, then serve warm or at room temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0023-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0024-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("WENTELTEEFJES, OR SAVORY FRENCH TOAST (THE DUTCH VERSION)")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_c('em', [_vm._v("Makes 6 to 8 slices, depending on size of bread")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("4 large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("½ cup (125 ml) milk")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("½ cup (125 ml) heavy cream")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 teaspoon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("½ cup (50 g) grated Parmesan cheese, plus extra for serving")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("A pinch of sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("A few drops of Tabasco sauce")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 tablespoon Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("6 to 8 slices of good-quality white bread; you can make lovely shapes using a cutter")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Some butter for frying")]), _vm._v(" "), _c('p', {
    staticClass: "ing1"
  }, [_c('strong', [_vm._v("FOR GARNISH")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("A salad of chopped fresh garden herbs such as chives, flat-leaf parsley, and/or basil and some arugula with a simple olive oil and vinegar vinaigrette")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("Wentelteefjes")]), _vm._v(" can be sweet, but they are tasty savory as well. Perfect for using up old bread, they make for an addictive Christmas breakfast.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Prepare")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whisk the eggs, milk, cream, and mustard until foamy. Stir in the cheese, season with some salt and pepper, a little Tabasco, and a splash of Worcestershire sauce. Pour the egg mixture into a shallow bowl. You can prepare the egg mixture the night before and store it in the fridge overnight.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Make")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place two slices of bread in the bowl—or as many you can fit, really—and let them soak for 1 to 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over medium heat, melt a cube of butter in a nonstick skillet and cook the soaked bread for about 2 minutes per side, until golden brown. Let drain on some paper towels while frying the remaining slices.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sprinkle with cheese and serve with the green herb salad.")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0027-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("CHRISTMAS WREATH BREAD")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_c('em', [_vm._v("Serves about 8")])]), _vm._v(" "), _c('p', {
    staticClass: "ing1"
  }, [_c('strong', [_vm._v("FOR THE DOUGH")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 cup (250 ml) milk")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("3½ tablespoons (50 g) butter, cubed")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("2¼ teaspoons (1 envelope) active dry yeast")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("3½ cups (450 g) all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("¼ cup (50 g) lightly packed light brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("½ teaspoon sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "ing1"
  }, [_c('strong', [_vm._v("FOR THE FILLING")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1⅓ cups (200 g) currants")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("⅓ cup (50 g) chopped succade (preserved or crystallized fruit)")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 teaspoon mixed spice ("), _c('em', [_vm._v("speculaaskruiden")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Zest and juice of 1 lemon")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Zest and juice of 1 orange")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("7 tablespoons (100 g) butter, at room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("2 tablespoons light brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 egg, lightly beaten")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Confectioners’ sugar for serving (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("First make the dough. In a saucepan, heat the milk until just below boiling, then add the butter and remove from the heat. Allow to cool for 5 minutes—until just below body temperature—then add the yeast to the now lukewarm milk. Let stand for another 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Combine the flour, brown sugar, and salt in a large bowl and form an indentation in the center. Pour in the milk mixture. Using a wooden spoon, combine until the dough holds together. Continue kneading with your hands on a lightly floured countertop for another 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shape into a ball, place in a greased bowl, cover, and let rise in a warm spot for 90 minutes, or until it has doubled in volume.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the filling, heat the currants, succade, cinnamon, mixed spice, and the lemon and orange zest and juice in a saucepan. Cook over very low heat, until the currants are nicely plumped up. Let cool. Mix in the butter and brown sugar and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Knead the dough briefly once more. On a lightly floured countertop, roll it out into a rectangle about 18 by 12 inches (45 by 30 cm). Spread the filling over it using a pancake spatula. Allow a margin of about ¾ inch (2 cm) at the long sides.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Roll up the dough from a long side, moisten the bare edge with water, and press to seal the seam. Place the roll with the seam facing down. Moisten the ends of the roll as well and bend them together, forming a circle. Place the wreath on a baking sheet lined with parchment paper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a sharp knife, cut into the roll every 1¼ inches (3 cm), almost all the way through, but not quite. Pull out each cut piece, exposing the sides, and the spirals will form a circular fan of swirls. Cover with a clean dish towel and allow the wreath to rise again for about 45 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brush the bread with the lightly beaten egg. Bake for about 30 minutes, until golden brown. Optionally, dust with confectioners’ sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0028-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("CLASSIC MINI MINCE PIES")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_c('em', [_vm._v("Makes about 24 tartlets")])]), _vm._v(" "), _c('p', {
    staticClass: "ing1"
  }, [_c('strong', [_vm._v("FOR THE DOUGH")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("2 cups (250 g) all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("2 tablespoons superfine sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("9 tablespoons (125 g) chilled butter, cubed")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 egg yolk")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("A pinch of salt")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Juice of 1 orange")]), _vm._v(" "), _c('p', {
    staticClass: "ing1"
  }, [_c('strong', [_vm._v("FOR THE FILLING")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("About 1 cup plus 2 tablespoons (350 g) mincemeat ("), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09#page_261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("this page")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Superfine or confectioners’ sugar, for serving")]), _vm._v(" "), _c('p', {
    staticClass: "ing1"
  }, [_c('strong', [_vm._v("ALSO NEEDED")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Mini muffin pan")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Of course they have to come out of a mini muffin pan: small two-bite pies, mincemeat-filled orange-flavored crusts with a star shape on top. Although a heart or some other Christmas shape is fine too!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It works best if you pulse the dough in a food processor to ensure the butter stays cold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Combine the flour, superfine sugar, butter, egg yolk, and salt until the mixture resembles coarse crumbs. Add the orange juice drop by drop until the dough is holding together. Shape into a flattened ball, wrap with plastic wrap, and set aside in the fridge for a couple of hours.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat the oven to 400°F (200°C). Thoroughly grease the cups of the mini muffin pan with butter or baking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On a floured countertop, roll out the dough into a slab ¼ inch (½ cm) thick. Use a cookie cutter or a glass to cut out rounds about ⅜ inch (1 cm) larger than the diameter of the cups. Gently press them into the cups. If the dough tears, don’t worry; just press lightly to fix it. Fill the tartlets with a generous coffee spoon or small tablespoon of mincemeat each.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gather all the leftover pieces of dough and roll them out into a thin slab again. Cut stars (or other shapes) using a cookie cutter. Place the shapes on top of the filling and lightly press.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake the tartlets for 10 to 15 minutes. They should lightly brown, although not too dark! Let cool in the pan for 3 minutes before scooping them out with a knife so they can cool further. Now you can use your muffin pan for another round if necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once cool, dust them with superfine or confectioners’ sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0029-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0031-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("KRISPY CHRISTMAS WREATHS")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_c('em', [_vm._v("Makes about 10 cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("8½ tablespoons (120 g) butter")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("¼ cup (60 ml) syrup, preferably golden syrup")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("¼ cup (25 g) cocoa powder")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("¼ cup (30 g) confectioners’ sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("¼ cup (35 g) dried cranberries (or other dried fruit)")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("3 to 4 handfuls of cornflakes or crispy rice cereal")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("15 to 20 Bigarreaux cherries, halved")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Melt the butter and syrup in a saucepan, stir in the cocoa powder, and remove from the heat. Fold in the confectioners’ sugar, cranberries, and cornflakes. Carefully combine until everything is coated with the butter mixture, but not wet. If necessary, add more cornflakes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Line a baking sheet that’s small enough to fit in your fridge with parchment paper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Use two spoons to form little heaps of the cornflakes mixture on the baking sheet. Using the back of a spoon, form holes in the middle of each, creating little wreaths. Decorate with the halved cherries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put the cookies in the fridge for 3 to 4 hours to firm up completely before you dig in.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0030-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0032-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0033-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0034-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("SQUASH, FETA & SAGE PULL-APART BREAD")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_c('em', [_vm._v("Serves about 6, depending on what else is offered at the table")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 cup (250 ml) lukewarm water")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("2 teaspoons honey (or sugar)")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("2¼ teaspoons (1 envelope) instant yeast")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("3 cups plus 2 tablespoons (400 g) all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 teaspoon sea salt, plus a little extra")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("About 14 ounces (400 g) butternut squash (about ½ squash), peeled and cubed")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("A splash of olive oil for greasing")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 teaspoon paprika")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("3½ ounces (100 g) feta cheese, cut into ⅜-inch (1-cm) cubes")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("12 fresh sage leaves, 4 leaves finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 egg, beaten")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a pitcher, combine the lukewarm water with the honey and yeast. Let stand for 7 minutes, or until it begins to foam and all the yeast has dissolved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mix the flour and 1 teaspoon salt in a wide bowl and form an indentation in the middle. Pour the yeast mixture into the indentation. Stir until the dough starts to hold together and continue kneading for at least 10 minutes on a floured countertop until you have a soft and supple dough that is no longer sticky and bounces back when you poke it. Place the ball in a greased bowl, cover with plastic wrap, and set aside for 1 hour in a warm and draft-free spot so the dough can rise and double in size.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Spread the squash cubes out on a greased baking sheet, sprinkle with salt, pepper, and paprika, and roast for 30 minutes, or until they are just tender and the edges begin to brown. Let cool.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the dough has risen, knead it again briefly. Grease a rectangular 9 by 5-inch (23 by 12-cm) loaf pan with oil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Roll the dough out into a 6 by 10-inch (15 by 25-cm) rectangle. Sprinkle with the squash cubes, feta, and chopped sage, leaving the edges clear. Roll up the dough from a short side into a thick log. Cut the log into twelve equal slices and quickly roll those into balls. Arrange six of them in the bottom of the loaf pan and place a sage leaf on each ball. Then place more dough balls on top of each, seams alternating, until the pan is filled. Stick the rest of the sage leaves in between the balls. Cover with a clean cloth and let rise again, this time for only 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat the oven to 400°F (200°C) again. Brush the dough with the egg and bake for about 30 minutes, until golden brown. Allow to cool on a rack for 5 minutes, remove from the pan, and allow to cool completely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Serve with soup or a big salad.")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0036-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("APPLE-CRANBERRY CHRISTMAS ROLLS")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_c('em', [_vm._v("Makes 6 substantial rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("6 tablespoons plus 1 teaspoon (90 g) butter")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("½ cup plus 2 tablespoons (125 g) sugar, plus a little extra")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("2 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("½ cup (125 g) applesauce, home made or from a jar")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("About ⅓ cup (70 ml) milk")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("3 cups plus 2 tablespoons (400 g) all-purpose flour, sifted")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("A pinch of salt")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Zest of ½ lemon")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("⅔ cup (100 g) dried cranberries")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 apple, peeled and diced")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Confectioners’ sugar")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Prepare")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Beat the butter together with the sugar for about 3 minutes, until smooth and creamy. Add the eggs, one at the time. While beating, add the applesauce and milk, then spoon in the sifted flour, then the salt, lemon zest, cranberries, and apple. The dough should be nice and soft, not too dry. If needed, add a few drops of milk. Grease six muffin tins. Fill them with the apple-cranberry mixture. (Or do as I do: Use a large ice cream scoop to form six to eight balls of batter and place them on a parchment paper–lined baking sheet.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Let stand for 15 minutes before baking. You can also prepare them the evening before and store them in a cool place.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Make")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 335°F (170°C).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake the rolls for 40 to 45 minutes. Dust with confectioners’ sugar. They are best when still a bit warm.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0037-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0039-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("SAUSAGE BUNS WITH FENNEL")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_c('em', [_vm._v("Makes about 10 buns")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("A knob of butter")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 red onion, finely diced")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 smallish fennel bulb, cored and diced")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("3 to 4 tablespoons red wine, vermouth, or water")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("18 ounces (500 g) fresh pork sausages, preferably with fennel seeds")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("About ¾ cup (70 g) fresh breadcrumbs (made from day-old bread; otherwise use store-bought)")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 teaspoon fennel seeds, crushed in a mortar, plus a little extra for sprinkling")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("½ teaspoon caraway seeds, crushed in a mortar")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 (17.3-ounce/490-g) box frozen puff pastry dough (2 sheets), thawed")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 egg, beaten")]), _vm._v(" "), _c('p', {
    staticClass: "ing1"
  }, [_c('strong', [_vm._v("LITTLE SIDE NOTE")])]), _vm._v(" "), _c('p', {
    staticClass: "ingn"
  }, [_vm._v("As long as I can remember, we have been calling these "), _c('em', [_vm._v("worstenbroodjes")]), _vm._v(", or sausage buns, at our house. Since they are made with puff pastry they should technically be called "), _c('em', [_vm._v("saucijzenbroodjes")]), _vm._v(", or sausage turnovers. But my parents proudly hail from the southern Dutch province of Limburg, an area where the word "), _c('em', [_vm._v("worstenbroodje")]), _vm._v(" is so deeply rooted that I have simply always associated it with Christmas food. When hearing “sausage "), _c('em', [_vm._v("turnover")]), _vm._v(",” on the other hand, I think more of a greasy pastry you pick up at a train station.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In my book "), _c('em', [_vm._v("Home Made Winter")]), _vm._v(", I told you the story of how my mother, Mariëtte, would bake a whole batch of sausage buns at the beginning of each winter break. We would eat them throughout the holidays: for breakfast, as a snack, for lunch, a lazy dinner, or while lounging on the sofa, watching a Christmas movie on TV. Now, several years later, her recipe has traveled the globe, and people from all over have been sending me pictures of their own Christmas buns. I love it!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now I’d like to add a new recipe to your repertoire. These sausage buns are really delicious as well—and easy to make, to boot—as long as you buy the right type of sausage. (I love a fennel seed, red wine sausage made by Dutch artisans Brandt & Levie, but you can find your own freshly made local variety.) Basically all you have to do is swaddle it in a blanket of dough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a large frying pan, melt the butter over medium heat. Add the onion and fennel and fry, stirring now and then. After 5 minutes, pour in several tablespoons of the wine and continue cooking until tender, about 15 minutes, adding more liquid if needed to keep the vegetables from sticking. Remove from the heat and let cool somewhat on the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remove the casings from the sausages and crumble the meat in a mixing bowl. Combine the fried onion and fennel with the meat, add the bread-crumbs, fennel seeds, and caraway seeds. Knead together until homogenous. Season to taste with a couple pinches of salt and pepper if necessary, but be careful: The sausages themselves are already seasoned!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Line a rimmed baking sheet with parchment paper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Divide the sausage mixture into ten balls. Using your wet hands, shape them into sausage-sized logs (about 4½ inches/11 cm long). Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Roll out each sheet of puff pastry to an 11-inch (28-cm) square. Cut each into six rectangles (cut in half one way, then into thirds the other way). You’ll need ten rectangles total; set two rectangles aside for another use.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Place each sausage log in the center of a puff pastry rectangle, brush one long side of each dough rectangle with a bit of the beaten egg, and wrap the dough around the sausage, pinching the seam and ends together very securely—if these leak as they bake, the bottoms will get soggy, so take care to seal them well. Place on the prepared baking sheet, seams down. Brush the tops with more beaten egg and sprinkle with some fennel seeds. Bake for about 25 minutes, until nicely golden brown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once cooled and wrapped, you can store them in the fridge for the rest of your Christmas break (about a week), so why not make a whole lot of them?")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0040-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("OATMEAL PANCAKES")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_c('em', [_vm._v("Makes about 16 pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("2¼ cups (200 g) rolled oats")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("2 teaspoons baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("½ teaspoon plus a pinch of salt")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 teaspoon cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("4 eggs, separated")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("¾ cup plus 1 tablespoon (200 ml) milk")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("A little butter for cooking")]), _vm._v(" "), _c('p', {
    staticClass: "ing1"
  }, [_c('strong', [_vm._v("FOR ON TOP")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Cranberry compote (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09#page_266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("this page")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Some fruit, melted butter, golden syrup, maple syrup, or confectioners’ sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is a recipe for the fluffiest, most delicious pancakes ever. I know I’ve said this before in my book "), _c('em', [_vm._v("Home Made Summer")]), _vm._v(", but it’s true. I did manage to improve my own recipe. Man, oh man, how wonderful these are. And to complete a truly royal Christmas breakfast you can serve them along with my cranberry compote.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grind the oatmeal into fine flour in a food processor. This will take just a sec.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Add the baking powder, ½ teaspoon salt, and the cinnamon and combine by pressing the pulse button a few times. In a bowl, whisk the egg yolks together with the milk and add the dry ingredients from the processor, stirring to combine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a clean bowl, with a clean whisk, whisk the egg whites and a pinch of salt until stiff. Fold into the batter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Heat a small lump of butter in a nonstick skillet. Spoon in a ladle of batter and cook three pancakes at a time over low to medium heat. Use a pancake spatula to flip them when the underside has browned and cook for another 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Serve with some delicious toppings, and dust with confectioners’ sugar if you like.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0041-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0043-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("CRUNCHY BLACKBERRY & APPLE COCOTTES")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_c('em', [_vm._v("Makes 2 large or 4 small cocottes, or 1 large oven dish")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1¾ cups (250 g) blackberries")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 apple, peeled and diced")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Heaping ¼ cup (60 g) packed dark brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 teaspoon cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("A pinch of salt")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("2½ cups (250 g) granola")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("4 tablespoons (55 g) butter, at room temperature, plus more for the baking dishes")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Prepare")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Grease the cocottes or baking dishes with some butter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Combine the blackberries and apple with the brown sugar, cinnamon, and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In another bowl, mix the granola with the butter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Divide the blackberry-apple mixture among the cocottes and, if you want to bake them right away, sprinkle with the granola mixture. If you are preparing for the next day, keep the granola mixture separate, cover everything, and store the fruit-filled cocottes in the fridge until you are ready to bake.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Make")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 350°F (180°C).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Spoon the granola mixture on top of the fruit in the cocottes. Bake for about 25 minutes, until the fruit is bubbling and the granola is nicely crunchy. Serve with some yogurt or crème anglaise ("), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09#res-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("this page")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0045-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("SCOTTISH EGGS")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_c('em', [_vm._v("Serves 4 as a brunch or lunch dish")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("6 eggs, as fresh as possible")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("2 small handfuls of all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("About 3⅓ cups (100 g) cornflakes, finely ground")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("1 pound 5 ounces (600 g) nice sausages (I prefer chunky, fresh ones from an artisanal producer)")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Vegetable oil for deep-frying")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_vm._v("Mustard for serving")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Prepare")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place 4 eggs in a saucepan, add water until they’re well submerged. Bring to a boil, cover, and let stand for 4 minutes. Rinse the eggs with ice-cold water or place them in ice water. Carefully peel them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put the flour in one bowl. Whisk the 2 remaining eggs in a second bowl. Put the ground cornflakes in a third bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remove the casings from the sausages. Divide the meat into four portions. In the palm of your hand, press the meat into a thin patty. Carefully wrap it around one of the soft-boiled eggs. Secure it by gently pressing while making sure not to damage the egg. Now roll the wrapped egg in the flour. Gently tap to remove any excess. Dip it in the beaten eggs, then roll it in the cornflakes. Repeat for the rest of the eggs and sausage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Allow the balls to firm up in the fridge for 1 hour. Longer is also fine, of course, up to overnight.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Make")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Heat 2 inches (5 cm) of the oil in a wok or deep-fryer. If you have a thermometer, the oil should reach a temperature of about 335°F (170°C)—not too hot. Deep-fry the balls until nicely golden brown and crispy, 5 to 6 minutes, turning them over halfway through.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Serve the Scottish eggs while still warm, with some mustard on the side.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 87
// module chunks = 0